var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sportFootballMatchStatusPeriodScore"},[_c('span',{staticClass:"title"},[_vm._v("Score")]),_c('span',{staticClass:"score"},[_vm._v(_vm._s(_vm.home)+" - "+_vm._s(_vm.away))])])
}
var staticRenderFns = []

export { render, staticRenderFns }